export default __webpack_public_path__ + "static/us-enterprise-learner-success-4776330b5cdb1aff05d1cbc7007dbb0d.gif";